export interface Module {
  title: string
  body: string
  tagline: string
  /** Repère couleur du module */
  color: string
  /** Module mis en avant sur la page */
  featured?: boolean
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — DIAGNOSTIC ÉLECTRONIQUE & OBD-II',
    body: 'Le cœur du système. L’autodiagnostic embarqué, la prise de diagnostic et l’usage professionnel du scanner : connexion, lecture et effacement raisonné des codes. La structure d’un code DTC, défaut présent, mémorisé ou intermittent, la lecture du freeze frame et les données en temps réel (corrections de richesse, température, charge, régime, sonde lambda, débit d’air). Avec tables DTC par famille, fiches de scan, arbres de décision et procédure de contrôle après réparation.',
    tagline: 'Un code indique une piste, jamais une pièce à changer d’office.',
    color: 'rgb(var(--color-module-1))',
    featured: true,
  },
  {
    title: 'MODULE 2 — DIAGNOSTIC MOTEUR, INJECTION & ALLUMAGE',
    body: 'Moteurs essence et diesel : alimentation en air et en carburant, injection, allumage, capteurs et actionneurs. Démarrage difficile, ratés, ralenti instable, fumées, perte de performance et mode dégradé, avec les causes probables classées de la plus simple à vérifier à la plus lourde.',
    tagline: 'Contrôler dans le bon ordre avant de remplacer.',
    color: 'rgb(var(--color-module-2))',
  },
  {
    title: 'MODULE 3 — DIAGNOSTIC ÉLECTRIQUE & ÉLECTRONIQUE AUTOMOBILE',
    body: 'Batterie, alternateur, démarreur, circuits, faisceaux, fusibles, relais, masses et calculateurs. Le multimètre pas à pas : tension, continuité, résistance, chute de tension sous charge, consommation parasite et localisation d’un défaut intermittent.',
    tagline: 'Mesurer au bon endroit pour conclure juste.',
    color: 'rgb(var(--color-module-3))',
  },
  {
    title: 'MODULE 4 — DIAGNOSTIC TRANSMISSION & SYSTÈMES DE TRANSMISSION',
    body: 'Embrayage, boîte de vitesses manuelle, boîte automatique (BVA) et robotisée présentées dans leur principe, transmissions, cardans et différentiels. Tableaux de symptômes, fiches d’inspection, séquences d’essais routiers et arbres « bruit / vibration / à-coup ».',
    tagline: 'Relier chaque bruit et chaque à-coup à sa cause probable.',
    color: 'rgb(var(--color-module-4))',
  },
  {
    title: 'MODULE 5 — DIAGNOSTIC FREINAGE, SUSPENSION & DIRECTION',
    body: 'Freins, liquide de frein, ABS et ESP, suspension, amortisseurs, rotules, direction assistée hydraulique et électrique, vibrations, tirage et instabilité. Pour chaque symptôme : inspection, contrôles, causes probables et essai de validation.',
    tagline: 'Les organes de sécurité, contrôlés avec méthode.',
    color: 'rgb(var(--color-module-5))',
  },
  {
    title: 'MODULE 6 — MÉTHODES DE DIAGNOSTIC, PROCÉDURES & FICHES ATELIER',
    body: 'De la réception du véhicule à la restitution : questionnaire client, reproduction du symptôme, hiérarchisation des hypothèses, essais, documentation et vérification de la réparation. Ordres de diagnostic, fiches imprimables, checklists et cas pratiques fictifs résolus pas à pas.',
    tagline: 'Une méthode d’atelier, du premier contact au véhicule restitué.',
    color: 'rgb(var(--color-module-6))',
  },
]
